import Box from "@mui/material/Box";
import { motion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";

import type { RootState } from "@/store/store";
import { useAppSelector } from "@/store/storeHooks";
import { SIDEBAR_CLOSE, SIDEBAR_OPEN, } from "@/app/styles/global.style";
import { Sidebar } from "@/widgets";

const scrollPages = (pathname: string) =>
  [
    "order",
    "contract",
    "queue",
    "purchase",
    "income",
    "warehouse/products",
    "stock-car",
  ].some((path) => pathname.includes(path));
export const Layout = () => {
  const location = useLocation();
  const { value } = useAppSelector((state: RootState) => state.sideBarData);
  const isAuth = useAppSelector((store) => store.LoginState.isAuth);
  
  // Dev mode'da ham UI'ni ko'rsatish
  const isDevMode = localStorage.getItem("dev_mode") === "true";
  // Test uchun dev mode'ni yoqib qo'yamiz
  localStorage.setItem("dev_mode", "true");
  const hasToken = !!localStorage.getItem("token");

  if (isDevMode) {
    return (
      <>
        <Sidebar />
        <motion.div
          animate={{
            paddingLeft: value ? SIDEBAR_OPEN : SIDEBAR_CLOSE,
          }}
          style={{
            minHeight: "100vh",
            width: "100%",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
          className="home-container"
        >
          <div
            style={{
              paddingTop: "0",
              height: "100vh",
              overflow: "auto",
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <Box
              height={"100vh"}
              sx={{
                overflowY: scrollPages(location.pathname) ? "scroll" : "auto",
                backgroundColor: '#f5f5f5'
              }}
            >
              <Outlet />
            </Box>
          </div>
        </motion.div>
      </>
    );
  }
  
  const shouldShowSidebar = isAuth || hasToken;
  
  return shouldShowSidebar ? (
    <>
      <Sidebar />
      <motion.div
        animate={{
          paddingLeft: value ? SIDEBAR_OPEN : SIDEBAR_CLOSE,
        }}
        style={{
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
        className="home-container"
      >
        <div
          style={{
            paddingTop: "0",
            height: "100vh",
            overflow: "auto",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <Box
            height={"100vh"}
            sx={{
              overflowY: scrollPages(location.pathname) ? "scroll" : "auto",
              backgroundColor: '#f5f5f5'
            }}
          >
            <Outlet />
          </Box>
        </div>
      </motion.div>
    </>
  ) : null;
};
